import { cn } from '@/lib/utils'
import { useTeamEventParticipantsContext } from '../context/TeamEventParticipantsContext'
import EventActivityIssuesBadge from './EventActivityIssuesBadge'

type Props = {
  activity: wowaudit.EventActivity
  allEncounters?: boolean
}

const EventActivitySelectionCount = ({ activity, allEncounters }: Props) => {
  const { activityIssuesById } = useTeamEventParticipantsContext()
  const issues = activityIssuesById.get(activity.id)
  const selectedCount = issues?.selectedCount ?? 0
  const maxRaidSize = activity.maxRaidSize ?? null
  const isAtTargetSize =
    maxRaidSize !== null
      ? selectedCount >= activity.raidSize && selectedCount <= maxRaidSize
      : selectedCount === activity.raidSize

  if (!activity.active) {
    return <div className='text-xs text-muted-foreground h-5'>inactive</div>
  }

  return (
    <div className='h-5 flex items-center justify-between gap-2'>
      <span className='text-sm font-mono flex items-center gap-0.5'>
        <span
          className={cn(
            issues?.tooManyPlayers
              ? 'text-warning-foreground'
              : isAtTargetSize
              ? 'text-success-foreground'
              : 'text-foreground',
          )}
        >
          {selectedCount}
        </span>
        <span className='text-muted-foreground'>/</span>
        <span>{activity.raidSize ?? '-'}</span>
      </span>
      <EventActivityIssuesBadge
        activityId={activity.id}
        allEncounters={allEncounters}
      />
    </div>
  )
}

export default EventActivitySelectionCount
